import React, { useState, useEffect } from "react";
import { numberFormatter } from "../../../utils";

const SKUCountTable = (props: any) => {
	const data = props.data;
	return (
		<>
			<table className="common-table-ui">
				<thead>
					<tr>
						<th className="w-[40%]">Supplier</th>
						<th className="w-[15%]">#SKUs</th>
						<th className="w-[15%]">Sales</th>
						<th className="w-[20%]">
							#SKUs <br />
							(High SPA)
						</th>
						<th className="w-[20%]">
							Sales <br /> (High SPA SKUs)
						</th>
					</tr>
				</thead>
				<tbody>
					{Array.isArray(props.data) &&
						props?.data?.map((d: any, index: any) => {
							return (
								<tr key={index}>
									<td>{d.master_vendor_name}</td>
									<td>{numberFormatter(d.TotalSkus, 0)}</td>
									<td>
										{numberFormatter(d.TotalSales_2023, 0)}
									</td>
									<td>
										{numberFormatter(d.highSpaTotalSkus, 0)}
									</td>
									<td>
										{numberFormatter(
											d.highSpaSales_2023,
											0
										)}
									</td>
								</tr>
							);
						})}
				</tbody>
			</table>
		</>
	);
};

export default SKUCountTable;
